import createReactComponent from '../createReactComponent';
export default createReactComponent('slashes', 'IconSlashes', [
  ['path', { d: 'M14 5l-10 14', key: 'svg-0' }],
  ['path', { d: 'M20 5l-10 14', key: 'svg-1' }],
]);
